import "./style.css";
import { useEffect, useState, useCallback } from "react";
import { useGlobalToast } from '../../../stopOldToastGlobally.js';
import { AgGridReact } from "ag-grid-react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import debounce from "lodash/debounce";
import { Form } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import { PiPencilSimpleLineBold } from "react-icons/pi";
import { MdClear } from 'react-icons/md';
import { RiArrowDropDownLine } from "react-icons/ri";
import Widgets from "../../../components/Widgets";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Switch } from "@mui/material";
// -------------------------------------------------------
import {
  commonGetData,
  commonSaveData,
  initCommonState,
  initState,
} from "../../../redux/slices/commonSlice";
import {
  initEmpState,
  getEmployeeData,
  getEmployeeDataOne,
} from "../../../redux/slices/employeeSlice";
import {
  getEmployeePermissionListPath,
  deactivateEmployeePath,
  getEmployeeManageListPath,
  adminSystemAccessPath,
  getRMTeamLeaderListPath,
  getRMManagerListPath,
  getRMHeadListPath
} from "../../../services/config";
import CustomPagination from "../../../components/CustomPagination";
import {
  downloadCSV,
  getEmployeeFormattedDataOne,
  getCurrentDate,
  getInitials,
  getInitialColor,
} from "../../../services/commonServices";
import { HasPermission } from "../../../services/hasPermission";

import { useSelector } from "react-redux";
import TableSkeleton from "../../../components/table/TableSkeleton.js";

const PenaltyOvertime = ({
  dispatch,
  user,
  state,
  branchList,
  designationList,
  departmentList
}) => {
  const customToast = useGlobalToast();
  const roleStore = useSelector((state) => state.roles);
  const empStore = useSelector((state) => state.employee);

  const [usersList, setUsersList] = useState([]);
  const [staffList, setStaffList] = useState([]);

  const [staffListOne, setStaffListOne] = useState([]);
  const [filterStaffListOne, setFilterStaffListOne] = useState([]);

  const [selectedStaffId, setSelectedStaffId] = useState("");
  const [level, setLevel] = useState("");

  // const [roleList, setRoleList] = useState([]);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [selectedIsSystemAccess, setSelectedIsSystemAccess] = useState([]);
  const [filterUser, setFilterUser] = useState("");

  const [employeeName, setEmployeeName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [role, setRole] = useState(0);
  const [branch, setBranch] = useState(0);
  const [departmentId, setDepartmentId] = useState("")

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getStaffList = useCallback((individualStaffId) => {
    const path = `${getEmployeeManageListPath}${user.user_id}&individualStaffId=${individualStaffId}`;
    dispatch(getEmployeeData(path));
  }, []);

  const path = `${getEmployeePermissionListPath}${user.user_id
    }&branchId=${branch}&departmentId=${departmentId}&jobTitle=${jobTitle}&roleId=${role}`;

  const getEmployeeList = () => {
    setUsersList([]);
    setFilteredUsersList([]);
    getStaffList("0");
    dispatch(commonGetData(path));
    // dispatch(fetchData());
  };

  useEffect(() => {
    getEmployeeList();
  }, [jobTitle, branch, departmentId, role, dispatch, path]);

  const [rmLevelId, setRmLevelId] = useState("");

  const handleGetStaffList = (data, rmLevelNo) => {
    setEmployeeName(data.staffName);
    let staffId = data.staffId;
    setSelectedStaffId(staffId);
    let pathName = ""
    if (rmLevelNo == 1) {
      setRmLevelId(data.rmLevel1);
      pathName = getRMTeamLeaderListPath(staffId, user.user_id)
    } else if (rmLevelNo == 2) {
      setRmLevelId(data.rmLevel2);
      pathName = getRMManagerListPath(staffId, user.user_id)
    } else {
      setRmLevelId(data.rmLevel3);
      pathName = getRMHeadListPath(staffId, user.user_id)
    }

    const path = `${getEmployeeManageListPath}${user.user_id}&individualStaffId=${staffId}`;
    dispatch(getEmployeeDataOne(pathName));
  };

  useEffect(() => {
    if (empStore.empGetSuccess) {
      setStaffList(empStore.empGetData);
      dispatch(initEmpState());
    }

    if (state.commonGetSuccess) {

      if (state.commonGetData == undefined || state.commonGetData == "") {
        setUsersList([]);
        setFilteredUsersList([]);
        dispatch(initState());
      } else {
        if (filterUser) {
          handleSearch(filterUser, state.commonGetData);
        } else {
          if (state.commonGetData && state.commonGetData[0].staffName) {
            setUsersList(state.commonGetData);
            setFilteredUsersList(state.commonGetData);

            const d = state.commonGetData.map((item) => {
              return { staffId: item.staffId, isSystemAccess: item.isSystemAccess };
            });
            setSelectedIsSystemAccess(d);

            dispatch(initState());
          }

        }
      }
      dispatch(initState());
    }

    if (state.commonGetError) {
      setUsersList([]);
      setFilteredUsersList([]);
      setSelectedIsSystemAccess([]);

      dispatch(initState());
    }

    if (empStore.empGetSuccessOne) {
      setStaffListOne(empStore.empGetDataOne);
      setFilterStaffListOne(empStore.empGetDataOne);
      dispatch(initEmpState());
    }

    // if (roleStore.roleGetSuccess) {
    //   setRoleList(roleStore.roleGetData);
    //   dispatch(initRoleState())
    // }

    if (state.commonSuccess) {
      getEmployeeList();
      setIsSystemAccess(false);
      dispatch(initCommonState());
    }
    if (state.commonError) {
      setIsSystemAccess(false);
      dispatch(initCommonState());
    }
  }, [state, empStore, roleStore]);

  const handleActiveInactiveChange = (event, rowData) => {
    const data = {
      path: deactivateEmployeePath,
      data: {
        userId: user.user_id,
        staffId: rowData.staffId,
        isActiveUser: event.target.value,
      },
    };
    dispatch(commonSaveData(data));
  };

  // const handleApprovalChange = (e, idx) => {
  const handleApprovalChange = (e) => {
    const {
      target: { value },
    } = e;
    const data = JSON.parse(value);
    // const newAssignees = [...mainState.approvalSettings];
    // newAssignees[idx].staffId = data.staffId;
    // newAssignees[idx].assigneeName = data.full_name;
    // newAssignees[idx].roleId = data.emp_role;
    // setMainState({ ...mainState, approvalSettings: newAssignees });
  };

  // const [adminSystemAccess, setAdminSystemAccess] = useState({});
  const [isSystemAccess, setIsSystemAccess] = useState(false);

  const closeIsSystemAccess = () => {
    setIsSystemAccess(false)
    setEmpSearch("")
  }

  // const systemAccess = (data) => {
  //   setAdminSystemAccess(data);
  //   setIsSystemAccess(true);
  // };

  const submitSystemAccess = () => {
    setIsSystemAccess(false);
  };

  const theme = localStorage.getItem("theme")

  const columns = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      field: "employeeId",
      width: 120,
      pinned: "left",
    },
    {
      headerName: "Name",
      pinned: "left",
      cellRenderer: (rowData) => {
        return (
          <>
            <Link
              style={{ textDecoration: "none" }}
              to={`user-info/${rowData.data.staffId}`}
              className="table-link d-flex align-items-center justify-content-start gap-2"
            >
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid lightgray",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: getInitialColor(rowData.data.staffName), // 🎯 Apply color
                  color: "white", // Text contrast
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                {getInitials(rowData.data.staffName)}
                {/* <img
                  src={Avatar}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                /> */}
              </div>
              {rowData.data.staffName}
              {/* <ArrowForwardIcon style={{ fontSize: "16px" }} /> */}
            </Link>
          </>
        );
      },
      width: "350px",
    },

    {
      headerName: "Branch",
      field: "branchName",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },

    {
      headerName: "Department",
      field: "departmentName",
      cellRenderer: (rowData) => {
        return rowData.data.departmentName ? rowData.data.departmentName : "-";
      },
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },

    {
      headerName: "Designation",
      cellRenderer: (rowData) => {
        return rowData.data.jobTitle ? rowData.data.jobTitle : "-";
      },
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
    },

    // {
    //   headerName: "Role",
    //   cellRenderer: (rowData) => {
    //     return (
    //       <div
    //         className="d-flex align-items-center justify-content-center"
    //         style={{ height: "100%" }}
    //       >
    //         {rowData.data.roleName ? rowData.data.roleName : "-"}
    //       </div>
    //     );
    //   },
    //   autoHeight: true,
    //   wrapText: true,
    //   resizable: true,
    //   cellClass: "custom-wrap-cell",
    //   width: "170px",
    // },

    {
      headerName: "RM Level 1",
      field: "reportingManager",
      cellRenderer: (rowData) => {
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <div
              className="ellipsis"
              style={{
                position: "relative",
                backgroundColor: "transparent",
                border: "1px solid gray",
                borderRadius: "12px",
                height: "35px",
                width: "180px",
                lineHeight: "35px",
                paddingLeft: "10px",
                marginTop: "2px",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleGetStaffList(rowData.data, 1);
                setLevel("1");
                setIsSystemAccess(true);
              }}
            >
              {(() => {
                const managerName =
                  staffList?.find(
                    (row1) => row1.staffId == rowData.data.rmLevel1
                  )?.full_name || "Select Manager";
                return managerName;
              })()}

              <RiArrowDropDownLine
                style={{
                  position: "absolute",
                  right: "7px",
                  top: "5px",
                  color: theme == "light" ? "#000" : "#fff",
                  fontSize: "25px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
        );
      },
      width: "200px",
    },

    {
      headerName: "RM Level 2",
      field: "reportingManager",
      cellRenderer: (rowData) => {
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <div
              className="ellipsis"
              style={{
                position: "relative",
                backgroundColor: "transparent",
                border: "1px solid gray",
                borderRadius: "12px",
                height: "35px",
                width: "180px",
                lineHeight: "35px",
                paddingLeft: "10px",
                marginTop: "2px",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleGetStaffList(rowData.data, 2);
                setLevel("2");
                setIsSystemAccess(true);
              }}
            >
              {(() => {
                const managerName =
                  staffList?.find(
                    (row1) => row1.staffId == rowData.data.rmLevel2
                  )?.full_name || "Select Manager";
                return managerName;
              })()}
              <RiArrowDropDownLine
                style={{
                  position: "absolute",
                  right: "7px",
                  top: "5px",
                  color: theme == "light" ? "#000" : "#fff",
                  fontSize: "25px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
        );
      },
      width: "200px",
    },

    {
      headerName: "RM Level 3",
      field: "reportingManager",
      cellRenderer: (rowData) => {
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "100%" }}
          >
            <div
              className="ellipsis"
              style={{
                position: "relative",
                backgroundColor: "transparent",
                border: "1px solid gray",
                borderRadius: "12px",
                height: "35px",
                width: "180px",
                lineHeight: "35px",
                paddingLeft: "10px",
                marginTop: "2px",
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleGetStaffList(rowData.data, 3);
                setLevel("3");
                setIsSystemAccess(true);
              }}
            >
              {(() => {
                const managerName =
                  staffList?.find(
                    (row1) => row1.staffId == rowData.data.rmLevel3
                  )?.full_name || "Select Manager";
                return managerName;
              })()}

              <RiArrowDropDownLine
                style={{
                  position: "absolute",
                  right: "7px",
                  top: "5px",
                  color: theme == "light" ? "#000" : "#fff",
                  fontSize: "25px",
                  cursor: "pointer",
                }}
              />
            </div>
          </div>
        );
      },
      width: "200px",
    },

    {
      headerName: "System Access",
      field: "systemAccess",
      cellRenderer: (rowData) => {
        return (
          <Switch
            checked={rowData.data.isSystemAccess == "1"}
            onChange={(e) => adminSystemAccess(e, rowData.data)}
          />
        );
      },
      width: "130px",
    },

    {
      headerName: "Action",
      pinned: "right",
      width: "150px",
      cellRenderer: (rowData) => {
        return (
          <div
            style={{ position: "relative", top: "9px" }}
            className="d-flex align-items-center justify-content-start gap-3"
          >
            <select
              className={
                rowData.data.status == "1" && rowData.data.status !== null
                  ? "statusGreen"
                  : "statusOrange"
              }
              value={rowData.data.status}
              onChange={(e) => handleActiveInactiveChange(e, rowData.data)}
            >
              <option
                value="1"
                selected={rowData.data.status == "1" && "selected"}
              >
                Active
              </option>
              <option
                value="0"
                selected={rowData.data.status !== "1" && "selected"}
              >
                InActive
              </option>
            </select>
            <Link
              to={`user-info/${rowData.data.staffId}`}
              className="table-link d-flex align-items-center justify-content-start gap-2"
              style={{ fontSize: "24px" }}
            >
              <PiPencilSimpleLineBold className="edit-icon" />
            </Link>
          </div>
        );
      },
    },
  ];

  const handleSearch = useCallback(
    debounce((query, dataList) => {
      const debouncedQuery = query.trim().toLowerCase();
      const results = dataList.filter(
        (employee) =>
          (employee.staffName &&
            employee.staffName.toLowerCase().includes(debouncedQuery)) ||
          (employee.jobTitle &&
            employee.jobTitle.toLowerCase().includes(debouncedQuery)) ||
          (employee.employeeId &&
            employee.employeeId.toLowerCase().includes(debouncedQuery))
      );
      setFilteredUsersList(results);
      setUsersList(dataList);
      const d = dataList.map((item) => {
        return { staffId: item.staffId, isSystemAccess: item.isSystemAccess };
      });
      setSelectedIsSystemAccess(d);
    }, 500),
    [usersList]
  );

  const searchUser = (event) => {
    const {
      target: { value },
    } = event;
    setFilterUser(value);
    handleSearch(value, usersList);
  };

  const downloadBulkData = () => {
    if (!filteredUsersList || filteredUsersList.length === 0) {
    customToast.warning("No data to export");  // ✅
    return;
  }

    downloadCSV(
      getEmployeeFormattedDataOne(filteredUsersList, 5),
      `${getCurrentDate()}_Permission_Detail.csv`
    );
    customToast.success("Permission details downloaded successfully!");
  };

  const paginationPageSize = 10;

  const adminSystemAccess = (e, row) => {
    const { checked } = e.target;

    const updatedList = filteredUsersList.map((staff) => {
      if (staff.staffId === row.staffId) {
        return {
          ...staff,
          isSystemAccess: staff.isSystemAccess === "1" ? "0" : "1",
        };
      }
      return staff;
    });
    setFilteredUsersList(updatedList);

    const data = {
      path: adminSystemAccessPath,
      data: {
        userId: user.user_id,
        staffId: row.staffId,
        isSystemAccess: checked ? 1 : 0,
        rmLevel1: "",
        rmLevel2: "",
        rmLevel3: "",
      },
    };
    dispatch(commonSaveData(data));
  };

  const handleReportingManger = (staffId) => {
    const data = {
      path: adminSystemAccessPath,
      data: {
        userId: user.user_id,
        staffId: selectedStaffId,
        isSystemAccess: "",
        rmLevel1: level == "1" ? staffId : "",
        rmLevel2: level == "2" ? staffId : "",
        rmLevel3: level == "3" ? staffId : "",
      },
    };
    dispatch(commonSaveData(data));
  };
  const [empSearch, setEmpSearch] = useState("");

  const handleSearchEmployeeDebounce = useCallback(
    debounce((query, dataList) => {
      const debouncedQuery = query.trim().toLowerCase();
      const results = dataList.filter(
        (employee) =>
          (employee.full_name &&
            employee.full_name.toLowerCase().includes(debouncedQuery)) ||
          (employee.job_title &&
            employee.job_title.toLowerCase().includes(debouncedQuery)) ||
          (employee.employeeId &&
            employee.employeeId.toLowerCase().includes(debouncedQuery)) ||
          (employee.departmentName &&
            employee.departmentName.toLowerCase().includes(debouncedQuery))
      );
      setStaffListOne(results);
      setFilterStaffListOne(dataList);
    }, 500),
    [staffListOne]
  );

  const handleSearchEmployee = (value) => {
    setEmpSearch(value);
    handleSearchEmployeeDebounce(value, filterStaffListOne);
  };

  const clearFilter = () => {
    setUsersList([]);
    setFilteredUsersList([]);
    getEmployeeList()
    setFilterUser("")
    setJobTitle("")
    setDepartmentId(0)
    setBranch(0)
  }

  return (
    <>
      <div className="search-box flex-space-between mt-m-40">
        <Form className="d-flex align-items-center justify-content-start gap-2">
          <Form.Group>
            <Form.Control
              placeholder="Search by Employee Name & ID"
              onChange={searchUser}
              name="filterUser"
              value={filterUser}
              className="universal-input-one"
              style={{ width: "250px" }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Select
              onChange={(e) => setJobTitle(e.target.value)}
              name="jobTitle"
              value={jobTitle}
              className="universal-input-one"
              style={{ width: "200px" }}
            >
              <option value="0">Select Job Title</option>
              {designationList?.map((row) => {
                return <option value={row.label} key={row.label}>{row.label}</option>;
              })}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Select
              onChange={(e) => setBranch(e.target.value)}
              name="branch"
              value={branch}
              className="universal-input-one"
              style={{ width: "200px" }}
            >
              <option value="0">Select Branch</option>
              {branchList?.map((row) => {
                return <option value={row.branchId} key={row.branchId}>{row.branch_name}</option>;
              })}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Select
              onChange={(e) => setDepartmentId(e.target.value)}
              name="departmentId"
              value={departmentId}
              className="universal-input-one"
              style={{ width: "200px" }}
            >
              <option value="0">Select Department</option>
              {departmentList?.map((row) => {
                return <option value={row.value} key={row.value}>{row.label}</option>;
              })}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            {
              (filterUser ||
                jobTitle ||
                departmentId != 0 ||
                branch != 0) && <button type="button" className="clear" onClick={clearFilter}>
                <MdClear /> Clear
              </button>
            }
          </Form.Group>
        </Form>
      </div>
      {/* ----------------------------------------------------- */}
      <Widgets
        body={
          <>
            <div
              className="ag-theme-quartz custom-grid"
              style={{ height: "calc(100vh - 310px)", width: "100%" }}
            >
              {state.commonGetLoading ? (
                <TableSkeleton />
              ) : (
                <AgGridReact
                  rowData={Array.isArray(filteredUsersList) ? filteredUsersList : []}
                  columnDefs={columns}
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              )}
            </div>
            <div className="d-flex align-items-center justify-content-between custom-pagination">
              {gridApi && <CustomPagination gridApi={gridApi} />}
              {HasPermission("Permission", "export") && (
                <Button
                  onClick={downloadBulkData}
                  className="bulkDataDownloads universal-btn"
                >
                  <FiDownload style={{ fontSize: "16px", marginRight: '10px' }} />
                  Export Data
                </Button>
              )}
            </div>
          </>
        }
      />

      {/* ----------------------------- */}

      <Dialog
        open={isSystemAccess}
        onClose={closeIsSystemAccess}
        fullWidth={true}
        maxWidth={"xs"}
        style={{ overflow: "visible" }}
        className="dark-bg-color"
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          <div className="dialog-title-icon">
            <span
              className="close-icon"
              onClick={closeIsSystemAccess}
            >
              X
            </span>
            <span className="title">{level == "1" ? "Select Manager" : level == "2" ? "Select Manager" : "Select Manager"}</span>
          </div>
          {/* <button className="universal-btn" >
            Submit
          </button> */}
        </DialogTitle>
        <DialogContent style={{ height: "auto" }}>
          <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
            <Form.Group>
              <span className="color-white">Employee Name: {employeeName}</span>
              <br />
              <Form.Label className="color-white mt-2">
                Select Reporting Manager
              </Form.Label>

              <Form.Control
                placeholder="Search Employee by Name, ID, job title & department"
                name="empSearch"
                value={empSearch}
                onChange={(e) => handleSearchEmployee(e.target.value)}
                className="universal-input mb-2 mt-2"
              />

              <div className="my-custom-dropdown">
                <div className="cd-title color-white">
                  {(() => {
                    const selectedManager = staffList.find(
                      (item) => item.staffId == rmLevelId
                    );
                    return selectedManager?.full_name ? selectedManager?.full_name : level == "1" ? "Select Manager" : level == "2" ? "Select Manager" : "Select Manager";
                  })()}

                  <RiArrowDropDownLine className="icon color-white" />
                </div>
                <ul className="cd-list">

                  {(() => {
                    const selectedManager = staffList.find(
                      (item) => item.staffId == rmLevelId
                    );
                    return selectedManager?.full_name ? <li
                      onClick={() => handleReportingManger("0")}
                      style={{ display: "flex", flexDirection: "column" }}
                      key={"init-0"}
                    >
                      <strong className="color-white">{level == "1" ? "Remove Manager" : level == "2" ? "Remove Manager" : "Remove Head"}</strong>
                    </li> : null
                  })()}

                  {staffListOne.map((staff, idx) => (

                    <li
                      onClick={() => handleReportingManger(staff.staffId)}
                      style={{ display: "flex", flexDirection: "column" }}
                      key={idx}
                    >
                      <strong className="color-white">{staff.full_name}</strong>
                      <small>
                        {staff.employeeId}
                        {staff.job_title && ` | ${staff.job_title}`}
                        {staff.departmentName && ` | ${staff.departmentName}`}
                      </small>
                    </li>
                  ))}
                </ul>
              </div>

              {/* <Form.Select
                onChange={handleReportingManger}
                className="universal-input-one-30"
                style={{ width: "100%" }}
              >
                <option value="">Select Manager</option>
                {staffListOne?.map((row1, idx) => {
                  return (
                    <option
                      value={JSON.stringify({
                        staffId: row1.staffId,
                        emp_role: row1.emp_role,
                        full_name: row1.full_name,
                      })}
                      key={idx}
                      selected={row1.staffId == rmLevelId ? "selected" : null}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                          gap: "10px",
                        }}
                      >
                        <h4>{row1.full_name}</h4>
                        <div>{row1.employeeId}</div>
                        <div>{row1.job_title}</div>
                        <div>{row1.department_name}</div>
                      </div>
                    </option>
                  );
                })}
              </Form.Select> */}
            </Form.Group>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PenaltyOvertime;
